module.exports = __webpack_public_path__ + "img/transition-2.6300055e.png";